import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import * as authActions from '../../actions/auth';
import * as registrationActions from '../../actions/registration';
import { Link } from 'react-router-dom';
import Header from '../Header';

const validationState = fromJS({
  first_name: false,
  last_name: false,
  email: {
    required: false,
    invalid: false,
    unique: false
  },
  gender: false,
  password: {
    required: false,
    match: false
  },
  zip: false,
  permissions: {
    eligibility: false,
    research: false,
    emergency: false,
    substitute: false 
  },
  preferences: {
    email: false,
    phone: false,
    phone_number: false,
    share: false
  }
});

class Register extends React.Component {
  state = {
    loading: false,
    validations: validationState.toJS()
  }

  componentWillMount() {
    if (this.props.registration.get('access_code') === '') {
      this.props.history.push('/access');
    }
  }

  validateEmail = email => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  checkValidations = () => {
    const props = this.props.registration.toJS();

    let validations = this.state.validations;

    if (props.first_name === '') validations.first_name = true;
    if (props.last_name === '') validations.last_name = true;
    if (props.email === '') validations.email.required = true;
    if (!this.validateEmail(props.email)) validations.email.invalid = true
    if (props.gender === '') validations.gender = true;
    if (props.zip === '') validations.zip = true;
    if (props.password === '') validations.password.required = true;
    if (props.password !== props.confirm) validations.password.match = true;

    return new Promise((resolve, reject) => {
      this.props._registration.validateEmail(props.email)
        .then(res => {
          if (res.status === 404 || res.status === 400) {
            if (JSON.stringify(validations) !== JSON.stringify(validationState.toJS())) {
              reject(false);
            }
            resolve(true);
          } else {
            validations.email.unique = true;
            reject(false);
          }

          this.setState({ validations: validations });
        });
    });
  }

  onChangeCheckbox = e => {
    const path = e.target.name.split('.');
    let validations = this.state.validations;
    validations[path[0]] = validationState.get(path[0]);

    this.props._registration.updateNestedProperty(path, !this.props.registration.get(path[0]).get(path[1]));
    this.setState({ validations: validations });
  }

  onChange = e => {
    let validations = this.state.validations;
    validations[e.target.name] = validationState.get(e.target.name);

    if (e.target.type === 'checkbox') {
      this.props._registration.updateProperty(e.target.name, e.target.value === 'on' ? true : false);
    } else {
      this.props._registration.updateProperty(e.target.name, e.target.value);
    }

    this.setState({ validations: validations });
  }

  save = e => {
    e.preventDefault();

    this.setState({ loading: true });

    this.checkValidations()
      .then(res => res && this.props._registration.register())
      .then(res => this.props._auth.login(res))
      .then(res => this.setState({ loading: false }))
      .then(res => this.props.history.push('/confirm'))
      .catch(err => console.log(err));
  }

  render() {
    const site = this.props.registration.get('site');
    const props = this.props.registration.toJS();

    return (
    <div>
      <section className="hero">
        <Header {...this.props} />
      </section>
      <section className="section">
        <div className="container">
          <h1 className="title is-3 has-text-centered" style={{marginBottom: "3rem"}}>Create your free account</h1>
          <form className="box" style={{ width: "80%", margin: "0px auto"}} onSubmit={this.save}>
            <div className="field is-horizontal">
              <div className="field-label is-normal">
                <label className="label">Name</label>
              </div>
              <div className="field-body">
                <div className="field">
                  <p className="control is-expanded">
                    <input 
                      autoFocus
                      className="input" 
                      type="text" 
                      name="first_name" 
                      placeholder="First name" 
                      value={props.first_name}
                      onChange={this.onChange} />
                  </p>
                  {this.state.validations.first_name && <p className="help is-danger">First name is required</p>}
                </div>
                <div className="field">
                  <p className="control is-expanded">
                    <input 
                      className="input" 
                      type="text" 
                      name="last_name" 
                      placeholder="Last name" 
                      value={props.last_name}
                      onChange={this.onChange} />
                  </p>
                  {this.state.validations.last_name && <p className="help is-danger">Last name is required</p>}
                </div>
              </div>
            </div>
            <div className="field is-horizontal">
              <div className="field-label is-normal">
                <label className="label">Email</label>
              </div>
              <div className="field-body">
                <div className="field">
                  <p className="control is-expanded">
                    <input 
                      className="input" 
                      type="email" 
                      name="email" 
                      placeholder="you@example.com" 
                      value={props.email}
                      onChange={this.onChange} />
                  </p>
                  {this.state.validations.email.required && <p className="help is-danger">This field is required</p>}
                  {this.state.validations.email.invalid && <p className="help is-danger">A valid email is required</p>}
                  {this.state.validations.email.unique && <p className="help is-danger">That email is already used</p>}
                </div>
                <div className="field">
                  <div className="control">
                    <label className="checkbox">
                      <input 
                        type="checkbox" 
                        checked={props.preferences.email} 
                        name="preferences.email" 
                        onChange={this.onChangeCheckbox} /> Contact me by email.
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="field is-horizontal">
              <div className="field-label is-normal">
                <label className="label">Phone</label>
              </div>
              <div className="field-body">
                <div className="field">
                  <p className="control is-expanded">
                    <input 
                      className="input" 
                      type="text" 
                      name="phone_number"
                      value={props.phone_number}
                      onChange={this.onChange} />
                  </p>
                </div>
                <div className="field">
                  <div className="control">
                    <label className="checkbox">
                      <input 
                        type="checkbox" 
                        checked={props.preferences.phone} 
                        name="preferences.phone" 
                        onChange={this.onChangeCheckbox} /> Contact me by phone.
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="field is-horizontal">
              <div className="field-label is-normal">
                <label className="label">Gender</label>
              </div>
              <div className="field-body">
                <div className="field is-narrow">
                  <div className="control">
                    <div className="select is-fullwidth">
                      <select name="gender" onChange={this.onChange}>
                        <option>Select one...</option>
                        <option value="male" selected={props.gender === 'male'}>Male</option>
                        <option value="female" selected={props.gender === 'female'}>Female</option>
                      </select>
                    </div>
                  </div>
                  {this.state.validations.gender && <p className="help is-danger">This field is required</p>}
                </div>
              </div>
            </div>
            <div className="field is-horizontal">
              <div className="field-label is-normal">
                <label className="label">Password</label>
              </div>
              <div className="field-body">
                <div className="field">
                  <p className="control is-expanded">
                    <input className="input" type="password" name="password" onChange={this.onChange} />
                  </p>
                  {this.state.validations.password.required && <p className="help is-danger">A password is required</p>}
                </div>
              </div>
            </div>
            <div className="field is-horizontal">
              <div className="field-label is-normal">
                <label className="label">Confirm</label>
              </div>
              <div className="field-body">
                <div className="field">
                  <p className="control is-expanded">
                    <input className="input" type="password" name="confirm" onChange={this.onChange} />
                  </p>
                  {this.state.validations.password.match && <p className="help is-danger">Passwords don't match</p>}
                </div>
              </div>
            </div>
            <div className="field is-horizontal">
              <div className="field-label is-normal">
                <label className="label">Zip Code</label>
              </div>
              <div className="field-body">
                <div className="field">
                  <p className="control is-expanded">
                    <input 
                      className="input" 
                      type="text" 
                      name="zip" 
                      value={props.zip}
                      onChange={this.onChange} />
                  </p>
                  {this.state.validations.zip && <p className="help is-danger">Please provide your zip code</p>}
                </div>
              </div>
            </div>
            <div className="field">
              <h2 className="title has-text-centered is-5">Permissions & Disclaimers</h2>
              <div className="box" style={{ width: "90%", margin: "0px auto"}} >
                <p className="content">
                  <label className="checkbox">
                    <input 
                      checked="true"
                      type="checkbox" 
                      name="permissions.services" 
                      onChange={this.onChangeCheckbox} /> Inform me about other services, novel treatments, and research for which I may be eligible.
                  </label>
                </p>
                <p className="content">
                  <label className="checkbox">
                    <input 
                      checked="true"
                      type="checkbox" 
                      name="premissions.eligibility" 
                      onChange={this.onChangeCheckbox} /> I grant permission to share data associated with this access code with my designated care provider.
                  </label>
                </p>
                <p className="content">
                  <label className="checkbox">
                    <input 
                      checked="true"
                      type="checkbox" 
                      name="permissions.research" 
                      onChange={this.onChangeCheckbox} /> Allow my de-identified treatment data to be used for clinical outcomes studies
                  </label>
                </p>
                <p className="content">
                  NOTICE: by creating an account ...<br />
                  <span className="is-size-7">
                  <span className="icon has-text-success"><i className="fa fa-check-square"></i></span> I acknowledge that I understand CCI is not an emergency service and cannot review or act on information I report.<br />
                  <span className="icon has-text-success"><i className="fa fa-check-square"></i></span> I acknowledge that I understand CCI reports are not a substitute for clinical evaluation and require professional review and interpretation.<br />
                  <span className="icon has-text-success"><i className="fa fa-check-square"></i></span> I acknowledge, and accept the <Link to="/terms">Terms of Service</Link></span>
                </p>
              </div>

            </div>
            <div className="field is-grouped is-grouped-centered">
              <p className="control">
                <button type="submit" disabled={this.state.loading} className="button is-primary">
                  {this.state.loading && <span className="icon is-small">
                    <i className="fa fa-spin fa-spinner"></i>
                  </span>}
                  {this.state.loading && ' '}
                  {this.state.loading ? " Setting up Account" : "Create Account"}
                </button>
              </p>
            </div>

          </form>
        </div>
      </section>
    </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    registration: state.registration
  };
}

function mapDispatchToProps(dispatch) {
  return {
    _auth: bindActionCreators(authActions, dispatch),
    _registration: bindActionCreators(registrationActions, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Register);



// WEBPACK FOOTER //
// ./src/components/pages/Register.js